const App = {
  APP_LOADING: 'app/app_loading',
  APP_LOADED: 'app/app_loaded',
};

export default App;